var _line, _line2, _line3, _line4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 44,
    viewBox: "0 0 95 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 26.5,
    x2: 95,
    y2: 26.5,
    stroke: "#D1B06B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 16.5,
    x2: 95,
    y2: 16.5,
    stroke: "#D1B06B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 44,
    x2: 52.5,
    y2: 2.18557e-8,
    stroke: "#D1B06B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 44,
    x2: 42.5,
    y2: 2.18557e-8,
    stroke: "#D1B06B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 7,
    height: 7,
    fill: "#D1B06B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsicon);
export default __webpack_public_path__ + "static/media/teamsicon.3d0fd6328f60f72dfc38cb786dc0c7d9.svg";
export { ForwardRef as ReactComponent };